export const veeStoreName = '__VueEchartsEditor__'
